import Accordions4i from "../../common/accordions25.js";
import FilterMenu from "./modules/filtermenu.js";
import SelectedFilters from "./modules/selectedfilters.js";
import RadioButtonFilter from "./modules/radiobuttonfilter.js";
import EventListeners from "./modules/eventlisteners.js";
import SubSearchFilter from "./modules/subsearchfilter.js";
import ColorSelectorFilter from "./modules/colorselectorfilter.js";
import ProductQuantityFilter from "./modules/productquantityfilter.js";
import UpdatePageFromUrl from "./modules/updatepagefromurl.js";

// TODO consider hiding pricemin/pricemax filter area when these two numbers are the same
const listAccordions = new Accordions4i();
const betterChoicesTagFilter = document.getElementById("betterChoicesTagFilter");

/**
 * Initializes the state of the product list page by setting up event listeners, updating filters based on the URL, and initializing various components such as accordions and star ratings.
 * @return {void}
 */
async function initializeState() {
    const loc = window.location.href;
    const title = document.title;
    const description = document.querySelector('meta[name="description"]').getAttribute('content');
    history.replaceState({ title: title, description: description }, '', loc);

    //polyfill for closest in IE
    if (window.Element && !Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            let matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i,
                el = this;
            do {
                i = matches.length;
                while (--i >= 0 && matches.item(i) !== el) { };
            } while ((i < 0) && (el = el.parentElement));
            return el;
        };
    }

    if (document.getElementById('PriceRange') !== null) {
        const { default: PriceRangeFilter } = await import('./modules/pricerangefilter.js');
        PriceRangeFilter.init();
    }

    listAccordions.init(document.getElementById("mainContent"));

    SubSearchFilter.events();
    ProductQuantityFilter.events();
    SelectedFilters.init(listAccordions);
    FilterMenu.events();
    ColorSelectorFilter.events();
    EventListeners.init();
    RadioButtonFilter.events();
    UpdatePageFromUrl.update(); 

    const { default: starRating } = await import("../../common/starrating25.js");
    starRating.init();

    //only in us/ca
    if (betterChoicesTagFilter) {
        updateBetterChoiceFilterAccordions();
        window.addEventListener('resize', updateBetterChoiceFilterAccordions);
    }

    // moved to one document event listener instead of multiple for performance
    // also trying to fix a bug and proteus isn't creating new bundles without a change in this file
    document.addEventListener("click", events);

    if (document.getElementById('rankOverridePopup')) {
        const { default: OverrideRankDialog } = await import('./dialogs/overriderank.js');
        OverrideRankDialog.init();
    }

    const { default: LogMetrics } = await import("./modules/logmetrics.js");
    LogMetrics.init();
};

async function events(e){
    const target = e.target;
    if(target.classList.contains("faveLink")){
        e.preventDefault();
        const faveLink = await loadModule('faveLink', '../favorites/modules/dropdown.js');
        faveLink.toggle(target);
    }else if(target.classList.contains("betterChoicesButton")){
        e.preventDefault();
        const isFirstLoad = !moduleCache['betterChoices'];
        const betterChoices = await loadModule('betterChoices', './dialogs/betterchoices.js');
        if (betterChoices) {
            if (isFirstLoad) betterChoices.init();
            betterChoices.open(e, target);
        }
    }else if(target.classList.contains("videoLink")){
        e.preventDefault();
        const isFirstLoad = !moduleCache['video'];
        const videoModule = await loadModule('video', '../../common/videos/videodialog.js');
        if (videoModule) {
            if (isFirstLoad) videoModule.init();
            videoModule.open(e, target);
        }
    }
}

const moduleCache = {};

/**
 * Lazily imports and caches a module.
 * @param {string} cacheKey - Unique key for caching.
 * @param {string} modulePath - The module path to import.
 * @returns {Promise<Object|null>} The default export or null if loading failed.
 */
async function loadModule(cacheKey, modulePath) {
    if (moduleCache[cacheKey]) { return moduleCache[cacheKey]; }
    try {
        const module = await import(modulePath);
        moduleCache[cacheKey] = module.default;
        return module.default;
    } catch (error) {
        console.error(`Error loading module ${modulePath}:`, error);
        moduleCache[cacheKey] = null;
        return null;
    }
}

/**
 * Updates the better choice filter accordions based on the current window width.
 * @return {void}
 */
function updateBetterChoiceFilterAccordions() {
    if (window.innerWidth < 600) {
        listAccordions.openAll(betterChoicesTagFilter);
    } else {
        listAccordions.openAll(betterChoicesTagFilter);
    }
};

try {
    await initializeState();
} catch (error) {
    console.error("ProductList Page initialization failed", error);
}